import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, Coins, Star, LogOut } from "lucide-react";
import { useClient } from "@/context/ClientContext";
import { useAuth } from "@/context/AuthContext";

export const TopStatsBar = () => {
  const { stats, level, client } = useClient();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const xp = stats?.xp || 0;
  const xpInLevel = xp % 100;

  return (
    <div className="sticky top-0 z-40 backdrop-blur-xl bg-white/75 border-b border-sky-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <button data-testid="home-logo-btn" onClick={() => navigate("/")} className="flex items-center gap-3 group min-w-0">
          <img src="/eyb-logo-full.png" alt="EYB Consulting" className="h-8 sm:h-9 w-auto group-hover:scale-105 transition-transform duration-300 shrink-0" />
          {client && (
            <span className="hidden sm:inline text-sm font-bold text-slate-400 truncate border-l border-slate-200 pl-3">
              {client.name}
            </span>
          )}
        </button>

        <div className="flex items-center gap-2 sm:gap-3">
          <Stat testid="stat-level" icon={<Star className="w-4 h-4 fill-sky-500 text-sky-500" />} value={`Lv ${level}`} sub={`${xpInLevel}/100`} />
          <Stat testid="stat-streak" icon={<Flame className="w-4 h-4 fill-orange-400 text-orange-500" />} value={stats?.bestStreak || 0} />
          <Stat testid="stat-coins" icon={<Coins className="w-4 h-4 fill-amber-400 text-amber-500" />} value={stats?.coins || 0} />
          <motion.button
            whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
            data-testid="logout-btn" onClick={logout} title="Log out"
            className="w-9 h-9 rounded-full flex items-center justify-center bg-white border-2 border-slate-100 text-slate-400 hover:text-rose-500 hover:border-rose-200 shadow-sm transition-colors"
          >
            <LogOut className="w-4 h-4" strokeWidth={2.5} />
          </motion.button>
        </div>
      </div>
    </div>
  );
};

const Stat = ({ icon, value, sub, testid }) => (
  <motion.div whileHover={{ scale: 1.06 }} data-testid={testid}
    className="flex items-center gap-1.5 bg-white border-2 border-slate-100 rounded-full px-3 py-1.5 shadow-sm">
    {icon}
    <span className="font-extrabold text-slate-800 text-sm tabular-nums">{value}</span>
    {sub && <span className="text-[10px] text-slate-400 font-bold hidden sm:inline">{sub}</span>}
  </motion.div>
);

export const DashboardHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-40 backdrop-blur-xl bg-white/75 border-b border-sky-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center group">
          <img src="/eyb-logo-full.png" alt="EYB Consulting" className="h-8 sm:h-9 w-auto group-hover:scale-105 transition-transform duration-300" />
        </button>
        <motion.button
          whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
          data-testid="logout-btn" onClick={logout} title="Log out"
          className="w-9 h-9 rounded-full flex items-center justify-center bg-white border-2 border-slate-100 text-slate-400 hover:text-rose-500 hover:border-rose-200 shadow-sm transition-colors"
        >
          <LogOut className="w-4 h-4" strokeWidth={2.5} />
        </motion.button>
      </div>
    </div>
  );
};
